export const enum ThemeEnum {
  Dark = "dark",
  Light = "light",
}

export type TThemeStyles = {
  primaryBackground: string
  secondaryBackground: string
  primaryColor: string
  secondaryColor: string
  primaryTextColor: string
}

export type TCustomizationListItemRes = {
  name: string
  dark: TThemeStyles
  light: TThemeStyles
  createdAt: number
  updatedAt: number
  createdBy: string
  updatedBy: string
}

export type TCustomizationListItem = {
  author: string
  name: string
  createdAt: number
  updatedAt: number
}

export type TCustomizationContextState = {
  data: {
    list: Array<TCustomizationListItem> | null
    error: unknown | null
  }
  item: {
    data: TCustomizationListItemRes | null
    error: unknown | null
    isLoading: boolean
  }
  update?: (state: Partial<TCustomizationContextState>) => void
}
